export interface IsActiveFlag {
    isActive: boolean;
}
